import { WifiSlash } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { useOnlineStatus } from '@/lib/ui/use-online-status'

/**
 * Read-only offline notice (D-046). Writes stay disabled by the API client,
 * which raises an explicit OFFLINE error instead of queueing background work.
 */
export function OfflineBanner() {
  const { t } = useTranslation()
  const online = useOnlineStatus()

  if (online) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-start gap-3 border-b border-line bg-mint px-4 py-3 text-deep"
    >
      <WifiSlash size={20} weight="bold" aria-hidden="true" className="mt-0.5 shrink-0" />
      <div className="min-w-0">
        <p className="text-sm font-bold">{t('common.offlineTitle')}</p>
        <p className="text-sm text-muted">{t('common.offlineBody')}</p>
      </div>
    </div>
  )
}
